import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import styled from 'styled-components';
import { Modal } from 'components';
import Markdown from 'markdown-to-jsx';
import { colors } from 'utils/colors';
import { AiToolset } from 'actions';
import { Header, Button, Popup, Icon } from 'semantic-ui-react';
import LogoSpinnerUpload from './LogoSpinnerAI';
import { generateOverviewPDF } from '../Overview/AskAi/BuildAiPdf';

class AiInsights extends Component {
  state = {
    isModalOpen: false,
    isDisclaimerOpen: false,
  };

  async componentDidUpdate() {
    const { portfolio, summaries, dispatch, loading, analytics } = this.props;

    const { isModalOpen } = this.state;
    const isAccount = !portfolio.id;

    let key = '';
    if (!portfolio.id && !portfolio.account) {
      key = 'temp';
    } else {
      key = `${
        isAccount
          ? portfolio.account.id
            ? portfolio.account.id
            : portfolio.account.user_institution
          : portfolio.id
      }::${isAccount}`;
    }

    if (isModalOpen && !loading) {
      if (!summaries.hasOwnProperty(key)) {
        dispatch(
          AiToolset.analyzeScorecard(await generateOverviewPDF(analytics), key)
        );
      }
    }
  }

  toggleModal = (isModalOpen) => {
    this.setState({ isModalOpen });
  };

  printModalContent = () => {
    const modalContent = document.getElementById('ai-modal-content');
    if (!modalContent) return;

    const printWindow = window.open('', '_blank', 'width=900,height=700');

    const printStyles = `
    <style>
      body { font-family: Arial, sans-serif; padding: 0.5rem 0 2rem 0; }
      h1 { color: #22347e; }
      p { font-size: 1rem; }
      .disclaimer {
        border: 2px solid rgb(108,135,252);
        border-radius: 8px;
        position: relative;
        padding: 1rem 1rem 0rem 1rem;
        margin-top: 2.5rem;
        margin-left: 1rem;
      }
      .disclaimer-header {
        position: absolute !important;
        top: -0.8rem !important;
        left: 0.6rem !important;
        background: white !important;
        display: inline-block;
        z-index: 10;
        text-align: left;
        font-size: 1.3rem;
      }
      .hidden {
        display: none !important;
      }
      .disclaimer-header .ui.button {
        display: none !important;
      }
      p strong {
        display: block;
        margin-bottom: 1rem;
      }
    </style>
  `;

    printWindow.document.write(`
    <html>
      <head>
        <title>Scorecard Insights</title>
        ${printStyles}
      </head>
      <body>
        ${modalContent.innerHTML}
        <script>
          window.onload = function() {
            setTimeout(function() {
              window.print();
              window.close();
            }, 250);
          };
        </script>
      </body>
    </html>
  `);
    printWindow.document.close();
  };

  render() {
    const { isModalOpen, isDisclaimerOpen } = this.state;
    const { portfolio, summaries, loading, error, french } = this.props;
    const isAccount = !portfolio.id;
    let key = '';
    if (!portfolio.id && !portfolio.account) {
      key = 'temp';
    } else {
      key = `${
        isAccount
          ? portfolio.account.id
            ? portfolio.account.id
            : portfolio.account.user_institution
          : portfolio.id
      }::${isAccount}`;
    }
    const summary = summaries[key];

    return (
      <Container>
        <Popup
          trigger={
            <OpenButton onClick={() => this.toggleModal(true)}>
              {french ? 'Aperçus IA' : 'AI Insights'}
              <Icon
                name="lightbulb outline"
                style={{
                  fontSize: '20px',
                  verticalAlign: 'initial',
                  color: 'white',
                  margin: 0,
                }}
              />
            </OpenButton>
          }
          position="top center"
          style={{ maxWidth: '350px' }}
        >
          <Popup.Content>
            {french
              ? 'Explorez des stratégies pour améliorer ce portefeuille. Assurez-vous d’avoir d’abord examiné les options/interrupteurs ci-dessus.'
              : 'Explore strategies to improve this portfolio. Make sure you have reviewed the toggles/options above first.'}
          </Popup.Content>
        </Popup>

        <Modal
          open={isModalOpen}
          dimmerClick={() => this.toggleModal(false)}
          style={{
            maxHeight: '75%',
            maxWidth: '52rem',
          }}
        >
          {loading ? (
            <React.Fragment>
              <CloseIcon
                className="close-icon"
                onClick={() => this.toggleModal(false)}
              >
                +
              </CloseIcon>
              <LogoSpinnerUpload french={french} />
            </React.Fragment>
          ) : (
            <div id="ai-modal-content">
              <Modal.Header>
                <CloseIcon
                  className="hidden"
                  onClick={() => this.toggleModal(false)}
                >
                  +
                </CloseIcon>
                <h1 style={{ fontWeight: 'bold', color: `${colors.navyBlue}` }}>
                  {french
                    ? 'Aperçus de la fiche d’évaluation'
                    : 'Scorecard Insights'}
                </h1>
                <p
                  style={{
                    fontSize: '1.14rem',
                    color: 'rgba(0,0,0,0.65)',
                    fontWeight: 'normal',
                  }}
                >
                  {french
                    ? 'En tirant parti de l’IA générative, les analyses stratégiques ci-dessous sont basées uniquement sur votre fiche d’évaluation de portefeuille Wealthscope.'
                    : 'Leveraging Generative AI, the strategic insights below are based solely on your Wealthscope Portfolio Scorecard.'}
                </p>
                <CollapseWrapper className="disclaimer" open={isDisclaimerOpen}>
                  <Header
                    className="disclaimer-header"
                    size="medium"
                    content="Disclaimer"
                    style={{
                      position: 'absolute',
                      top: isDisclaimerOpen ? '-11px' : '3px',
                      left: '.5rem',
                      background: 'white',
                      transition: 'all 300ms ease',
                      padding: '0 0.75rem 0 .5rem',
                    }}
                  >
                    <StyledButton
                      icon
                      onClick={() =>
                        this.setState({ isDisclaimerOpen: !isDisclaimerOpen })
                      }
                      isOpen={isDisclaimerOpen}
                      className="hidden"
                    >
                      {isDisclaimerOpen ? '-' : '+'}
                    </StyledButton>{' '}
                    {french ? 'Avertissement' : 'Disclaimer'}
                  </Header>
                  <div
                    style={{
                      fontSize: '1rem',
                      fontWeight: 'normal',
                      paddingBottom: '10px',
                    }}
                  >
                    {french
                      ? 'L’analyse ci-dessous a été générée avec l’aide de l’IA et est fournie à titre informatif seulement. Elle peut contenir des inexactitudes ou des informations incomplètes et ne doit pas être interprétée comme un conseil financier ou en investissement. Il est fortement recommandé de consulter des professionnels de la finance qualifiés et de mener vos propres recherches avant de prendre toute décision d’investissement. Votre fiche d’évaluation ne sera pas conservée par des tiers.'
                      : 'The analysis below has been generated with the assistance of AI and is provided for informational purposes only. It may contain inaccuracies or incomplete information and should not be interpreted as financial or investment advice. You are strongly encouraged to consult with qualified financial professionals and conduct your own research before making any investment decisions. Your Scorecard will not be stored by any third-parties.'}
                  </div>
                </CollapseWrapper>
              </Modal.Header>
              <Modal.Content
                style={{
                  position: 'relative',
                  padding: '0rem 2rem 2rem 2rem',
                  fontWeight: 'normal',
                  fontSize: '1rem',
                  alignItems: 'center',
                }}
              >
                <StyledMarkdown className="summary">
                  {error
                    ? french
                      ? 'Cette fiche de pointage n’a pas pu être analysée pour le moment. Veuillez actualiser votre navigateur et réessayer.'
                      : 'This Scorecard could not be analyzed at this time. Please refresh your browser and try again.'
                    : summary}
                </StyledMarkdown>
              </Modal.Content>
              <div
                className="hidden"
                style={{
                  position: 'sticky',
                  bottom: 0,
                  background: 'white',
                  padding: '1rem 0',
                  boxShadow: '0 -2px 8px rgba(0,0,0,0.04)',
                  height: '50px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 100,
                  borderTop: `2px solid ${colors.lightGrey}`,
                }}
              >
                <Button
                  active
                  basic
                  icon
                  labelPosition="right"
                  style={{
                    fontSize: '0.85em',
                    padding: '0.35em',
                  }}
                  onClick={this.printModalContent}
                >
                  {french ? 'Imprimer/PDF' : 'Print/PDF'}
                  <Icon
                    name="print"
                    style={{
                      fontSize: '15px',
                      verticalAlign: 'initial',
                      color: 'dimgrey',
                    }}
                  />
                </Button>
              </div>
            </div>
          )}
        </Modal>
      </Container>
    );
  }
}

AiInsights.propTypes = {
  portfolio: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
  summaries: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  analytics: PropTypes.object,
  french: PropTypes.bool,
};

AiInsights.defaultProps = {
  summaries: {},
  loading: false,
  analytics: {},
  error: '',
  french: false,
};

export default connect((state) => ({
  summaries: state.AiTools.summaries,
  loading: state.AiTools.loading,
  error: state.AiTools.error,
  pollingStatus: state.AiTools.pollingStatus,
  analytics: state.Analytics,
  french: state.Storage.language === 'fr',
}))(AiInsights);

const Container = styled.div``;

const OpenButton = styled.button`
  padding: 0.5px 1rem;
  font-size: 1rem;
  background: #22347e;
  background: linear-gradient(
    90deg,
    rgba(34, 52, 126, 1) 0%,
    rgba(108, 133, 248, 1) 25%,
    rgba(34, 52, 126, 1) 50%,
    rgba(108, 133, 248, 1) 75%,
    rgba(34, 52, 126, 1) 100%
  );
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

const CloseIcon = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  height: 20px;
  width: 20px;
  text-align: center;
  font-size: 1.7rem;
  border-radius: 50%;
  line-height: 19px;
  transform: rotate(45deg);
  transition: all 0.1s ease;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
    color: #fff6f6;
  }
`;

const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.isModalOpen ? colors.blue : 'white'} !important;
  color: ${(props) => (props.isModalOpen ? 'white' : colors.blue)} !important;
  border: ${(props) =>
    props.isModalOpen ? 'none' : `2px solid ${colors.blue}`} !important;
  border-radius: 50% !important;
  height: 2rem;
  width: 2rem;
  transition: all 0.9s ease-in-out !important;
  font-size: 1.3rem !important;
`;

const CollapseWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: ${(props) => (props.open ? '2rem 1rem 0' : '3rem 1rem 0')};
  margin: 1.5rem auto 0;
  border: ${(props) =>
    props.open ? `1px solid ${colors.blue}` : '1px solid white'};
  border-radius: 8px;
  overflow: ${(props) => (props.open ? 'visible' : 'hidden')};
  max-height: ${(props) => (props.open ? '2000px' : '38px')};
  transition: max-height 300ms ease, padding 300ms ease, border 300ms ease 300ms;
`;

const StyledMarkdown = styled(Markdown)`
  p {
    font-size: 1rem;
  }

  p strong {
    display: block;
    font-size: 1.14rem;
  }
`;
